/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './ServiceCoverageSummary.scss'
import { Collapse, CardBody, Card, CardHeader, Container } from 'reactstrap'
import { ServiceTypeHelper } from '../../../../utils/ServiceTypeHelper'
import { IBaseSection, ICoverageDiscoveryResponseStateManager } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IServiceCoverageSummaryProps {
	CoverageDiscoveryResponseStateManager: ICoverageDiscoveryResponseStateManager
}

interface IServiceCoverageSummaryState {
	collapse: number
}

export class ServiceCoverageSummaryComponent extends React.Component<IServiceCoverageSummaryProps, IServiceCoverageSummaryState> {
	constructor(props: Readonly<IServiceCoverageSummaryProps>) {
		super(props)
		this.toggle = this.toggle.bind(this)
		this.state = { collapse: 0 }
	}

	toggle(e: React.MouseEvent<HTMLElement, MouseEvent>): void {
		const event = e.currentTarget.dataset.event
		this.setState({ collapse: this.state.collapse === Number(event) ? 0 : Number(event) })
	}

	renderServiceCoverageData = (val: IBaseSection): JSX.Element[] => {
		const selectedSections = val.summary.selectedSections
		return ServiceTypeHelper.getMedicareSTC(val).map((res, index) => {
			return (
				<tbody key={index} className="summaryBody" style={{ display: res.code && selectedSections.indexOf(res.code) !== -1 ? '' : 'none' }}>
					<tr className={`summarySection ${res.isActive ? '' : 'noCoverage'}`}>
						<td colSpan={2}>
							<h4>
								{res.definition}&nbsp;({res.code})
							</h4>
						</td>
						<td className={res.isActive ? 'active' : 'alert alert-error'}>
							<strong>{res.status}</strong>
						</td>
						<td className="summaryDetails">
							<input type="hidden" value={res.code} />
						</td>
					</tr>
				</tbody>
			)
		})
	}

	render(): React.ReactNode {
		const { collapse } = this.state
		const section = this.props.CoverageDiscoveryResponseStateManager.selectedMedicareServiceCoverageSection
		if (!this.props.CoverageDiscoveryResponseStateManager.selectedMedicareServiceCoverageSection) return <></>
		else
			return (
				<div id={section.id} className="accordion-group service-coverage" data-loadorder={section.loadOrder} data-index={section.summary.index}>
					<Card style={{ marginBottom: '1rem' }} className="card" key={section.summary.index}>
						<CardHeader onClick={this.toggle} data-event={section.summary.index} className="service-coverage accordion-heading whiteText">
							{section.summary.title}
						</CardHeader>
						<Collapse isOpen={collapse === section.summary.index}>
							<CardBody className="card-body">
								<Container style={{ margin: 0, padding: 0, width: '100%' }}>
									<div className="cdResponsePage">
										<table className="service-types-table">
											<tbody>
												<tr className="summaryDisplaying">
													<td colSpan={4}>
														Displaying {section.summary.selectedSections.length} of {section.summary.sections.length} sections
													</td>
												</tr>
											</tbody>
											{this.renderServiceCoverageData(section)}
										</table>
									</div>
								</Container>
							</CardBody>
						</Collapse>
					</Card>
				</div>
			)
	}
}
